module.exports = __webpack_public_path__ + "static/media/magicbook-row.5729ea9b.png";